import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class HelperMethodService {
  pageTitle_beh = new BehaviorSubject('');

  constructor(public spinner: NgxSpinnerService,
    public toastr: ToastrService,private http:HttpClient
  ) {
  }
  loadNext(url) {
    return this.http.get(url);
  }
  presentToastr(message) {
    this.toastr.show(message);
  }

  presentToastrUnlimited(message) {
    this.toastr.show(message, '', {
      disableTimeOut: true
    });
  }

  presentSpinner() {
    this.spinner.show();
  }

  hideSpinner() {
    this.spinner.hide();
  }

  checkIfLoggedIn() {
    return localStorage.getItem('bogo_token');
  }

  checkIfhasPackage() {
    return localStorage.getItem('hasPackage');
  }

  setHasPackage(flag) {
    return localStorage.setItem('hasPackage', flag)
  }

  qrCodeRedirect(){
    return this.http.get('https://bogoplusapp.bit68.com/addons/api-v2/app-qr-code/')
  }
}
